(function () {
    const initSlider = () => {
        const sliders = document.querySelectorAll('.price-range__wrapper');

        for (const slider of sliders){
            const sliderEl = slider.querySelector('#price-slider');
            const minEl = slider.querySelector('#minPrice');
            const maxEl = slider.querySelector('#maxPrice');

            const minLabel = slider.querySelector('.price-range__min');
            const maxLabel = slider.querySelector('.price-range__max');

            sliderEl.addEventListener('input', () => {
                const min = sliderEl.minValue;
                const max = sliderEl.maxValue;

                minEl.value = min;
                maxEl.value = max;

                minLabel.textContent = min;
                maxLabel.textContent = max;
            });
        }
    }

    window.initSlider = initSlider;
    window.initSlider();
})();
